import { StyledTextField } from './CopyTextField.styled';
import { CopyButton } from './components';

type Props = {
  value: string;
};

export const CopyTextField = ({ value }: Props) => (
  <StyledTextField value={value} fullWidth InputProps={{ readOnly: true }} suffix={<CopyButton value={value} />} />
);
